<!--
     <DateTimeInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - value
     - class
     - label
     - format
-->

<template>
  <v-container class="pa-0 ma-0">
    <v-row>
      <v-col class="pt-0 pr-0">
        <DateInput
          :props="date_input_props"
          @update="update_day"
        ></DateInput>
      </v-col>

      <!-- Hours and minutes -->
      <v-col class="pt-0 pl-0 col-5">
        <v-text-field
          :value="hours"
          placeholder="HH:MM"
          :class="[props.class || props.readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input', {'required':props.required}]"
          :readonly="!!props.readonly"
          :rules="rules_hours"
          :error-messages="hour_error_messages"
          outlined
          dense
          background-color="#f2f2f2"
          @input="input_before_update"
          @change="update_hours"
        >
          <v-icon 
            v-if="!props.readonly"
            slot="append"
            color="primary"
          >
            {{ "mdi-clock" }}
          </v-icon>
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>

 import strftime from 'strftime'
 import DateInput from '@/components/inputs/DateInput.vue';
 export default {
   name: 'DateTimeInput',

   components: {
    DateInput,
   },

   props: ['props'],

   data: (() => ({
     menu: false,
     valid: true,
     day: null,
     hours: null,
     hour_error_messages: null,
     day_error_messages: null,
   })),

   computed: {
     formatted_date() {
       return this.value ? strftime(this.props.format || '%D', new Date(this.value))  : "";
     },

     field_value() {
      return this.props.value;
     },

     value() {
      return this.props.value || null;
      if (this.day && this.hours && false) {
        let datetime = new Date(this.day+' '+this.hours)
        return datetime.toISOString()
      } else if (this.props.value) {
        return this.props.value;
      } else {
        return null;
      }
     },

     rules() {
       // TODO: Multilang: Change hardcoded string
       return [(value) => !!value || !this.props.required || this.$vuetify.lang.translator('required_field')]
     },

     rules_hours() {
       return [
         (v) =>  !!v || !this.props.required || this.$vuetify.lang.translator('required_field'),
         (v) => !v || v.indexOf(':') >= 1 || 'HH:MM',
         (v) => !v || (v.split(':')[1]||'').length == 2 || 'HH:MM',
         (v) => !v || +v.split(':')[0] >= 0 && +v.split(':')[0] < 24 || this.$vuetify.lang.translator('invalid_hour'),
         (v) => !v || +v.split(':')[1] >= 0 && +v.split(':')[1] < 60 || this.$vuetify.lang.translator('invalid_minute'),
       ];
     },
     date_input_props() {
      return {...this.props, error_message: this.day_error_messages};
     },
   },

   mounted() {
    if (this.props.value) {
      let date = new Date(this.props.value);
      this.day = date.toISOString().split('T')[0];
      this.hours = ((''+date.getHours()).padStart(2, 0)
                     + ':'
                     + (''+date.getMinutes()).padStart(2, 0));
    }
   },

   methods: {
     pull_value() {
      if (!this.props.value) {
        this.day = null;
        this.hours = null;
      } else {
        const date = new Date(this.props.value);
        this.day = date.toISOString().split('T')[0];
        this.hours = ((''+date.getHours()).padStart(2, 0)
                      + ':'
                      + (''+date.getMinutes()).padStart(2, 0));
      }
     },
     
     validate() {
       // TODO: Show error message
       return !this.props.required || !!this.value;
     },

     valid_hours(time) {
      return +time.split(':')[0] >= 0 && +time.split(':')[0] < 24
     },

     valid_minutes(time) {
      return (time.split(':')[1]||'').length == 2 && +time.split(':')[1] >= 0 && +time.split(':')[1] < 60
     },

     valid_time(time) {
      return !time || (typeof(time) == 'string' && time.indexOf(':') >= 1 && this.valid_hours(time) && this.valid_hours(time));
     },

     clear() {
       this.hours = null;
     },

     error_state(ok) {
       this.valid = ok
     },

     update(value) {
      this.hour_error_messages = null;
      this.day_error_messages = null;
      this.$emit('update',value);
     },

     update_datetime() {
      if (!this.valid_time(this.hours)) return;
      if (this.day && this.hours) {
        let datetime = new Date(this.day+' '+this.hours);
        this.update(datetime.toISOString());
      } else if (!this.day && !this.hours) {
        this.update(null);
      }  else if (!this.day) {
        this.day_error_messages = this.$vuetify.lang.translator('required_field');
      } else if (!this.hours){
        this.hour_error_messages = this.$vuetify.lang.translator('required_field');
      }
     },

     input_before_update(hour) {
      if (!this.day && hour) {
        this.day_error_messages = this.$vuetify.lang.translator('required_field');
      } else {
        this.day_error_messages = null;
        if (this.day && (!hour || hour == "")) {
          this.hour_error_messages = this.$vuetify.lang.translator('required_field');
        } else {
          this.hour_error_messages = null;
        }
      }
      this.update_hours(hour);
     },

     update_hours(val) {
      this.hours = val;
      if (this.valid_time(this.hours)){
       this.update_datetime();
      }
     },
     
     update_day(value) {
      this.day = value;
      this.input_before_update(this.hours);
      this.update_datetime();
     },
   },

   watch: {
     props: {
       deep: true,
       value(val) {
         this.update_hours(val);
       },
       handler() {
         // Other property changes get ignored
       },
     },
     field_value() {
      this.pull_value();
     }
   },
 }
</script>

<style lang="scss">
 @import '@/sass/modalform.scss';
</style>
